// React
import { Fragment } from "react"

// Maps
import { APIProvider, Map } from "@vis.gl/react-google-maps"

// UI
import { MarkerWithInfowindow } from "./MarkerWithInfoWindow"

// GraphQL
import { usePublicProjectsMapsQuery } from "@/api/graphql"

// Constants
import {
	mapCoordinatesCenterOfNetherlands,
	ProjectCrowdfundingTypes,
} from "@/constants/constants"

// Env variables
import { GOOGLE_MAPS_API_KEY, GOOGLE_MAPS_ID } from "@/lib/env"
const MapTypeId = {
	HYBRID: "hybrid",
	ROADMAP: "roadmap",
	SATELLITE: "satellite",
	TERRAIN: "terrain",
}

/**
 * PublicProjectsMapsOverview
 * @param param0
 * @returns
 */
export function PublicProjectsMapsOverview() {
	const center = {
		lat: Number(mapCoordinatesCenterOfNetherlands.lat),
		lng: Number(mapCoordinatesCenterOfNetherlands.lng),
	}
	const zoom = 6

	// Fetch projects
	const { data } = usePublicProjectsMapsQuery({
		latitude: String(center.lat),
		longitude: String(center.lng),
		radius: "500",
		type: ProjectCrowdfundingTypes,
	})

	return (
		<APIProvider apiKey={GOOGLE_MAPS_API_KEY} libraries={["marker"]}>
			<Map
				mapId={GOOGLE_MAPS_ID}
				mapTypeId={MapTypeId.ROADMAP}
				className="size-full"
				defaultCenter={center}
				defaultZoom={zoom}
				gestureHandling={"scroll"}
				mapTypeControl={false}
				zoomControl={true}
				fullscreenControl={false}
				streetViewControl={false}
			>
				{/** Show all points of interest on the map */}
				{data?.public_projects?.results?.map((point) => (
					<Fragment key={point?.id}>
						{point?.latitude && point?.longitude && (
							<MarkerWithInfowindow
								key={point?.id}
								name={point?.name ?? ""}
								type={point?.type}
								start={point?.start}
								imageUrl={point?.image_url}
								position={{
									lat: point.latitude,
									lng: point.longitude,
								}}
							/>
						)}
					</Fragment>
				))}
			</Map>
		</APIProvider>
	)
}
